export default "__VITE_ASSET__R6uZGDxl__"